import { DatePipe } from '@angular/common';
import { FormatNumberPipe } from '../../../../../shared/pipes/number-separator.pipe';
import { EntityPopup, PopupInfoItem } from './entity-popup.interface';

export class CabezalPopup implements EntityPopup {
  private formatNumber = new FormatNumberPipe();
  private datePipe = new DatePipe('es-ES');

  constructor(private entity: any) {}

  getBadgeText(): string {
    return '';
  }

  getInfoItems(): PopupInfoItem[] {
    const formattedDate = this.datePipe.transform(
      this.entity.current_datetime,
      'dd/MM/yyyy HH:mm:ss'
    );

    return [
      {
        icon: 'water',
        label: 'Caudal',
        value: this.entity.current_flow,
        unit: 'm³/h',
        date: formattedDate,
      },
      {
        icon: 'swap_driving_apps_wheel',
        label: 'Presión de entrada',
        value:
          this.entity.current_inlet_pressure != null
            ? this.entity.current_inlet_pressure.toFixed(2)
            : null,
        unit: 'bar',
        date: formattedDate,
      },
      {
        icon: 'swap_driving_apps_wheel',
        label: 'Presión de salida',
        value:
          this.entity.current_outlet_pressure != null
            ? this.entity.current_outlet_pressure.toFixed(2)
            : null,
        unit: 'bar',
        date: formattedDate,
      },
      {
        icon: 'water_ph',
        label: 'pH',
        value: this.entity.current_pH,
        date: formattedDate,
      },
      {
        icon: 'water_ec',
        label: 'CE',
        value: this.entity.ce_ds_m,
        unit: 'ds/m',
        date: formattedDate,
      },
      {
        icon: 'readiness_score',
        label: 'Última lectura',
        value:
          this.entity.current_accumulated != null
            ? this.entity.current_accumulated.toFixed(2)
            : null,
        unit: 'm³',
        date: formattedDate,
      },
    ];
  }
}
